import { useContext, useLayoutEffect, useState } from 'react';
import { useSettings } from '@wu/widget-core';
import { currentVideoContext } from '../../currentVideoContext';
import { VimeoPlayer } from './vimeo-player';

export const Player = ({ item, nextVideo = () => {} }) => {
  const { player_embed_url } = item;
  const {
    playing,
    setPlaying,
    currentVideo,
    autoplay: autoplayFromContext
  } = useContext(currentVideoContext);

  const [, setVideo] = useState(currentVideo);
  const { finishAction, autoplay, playMode, source, displayDeactivation } =
    useSettings();
  const currentAutoplay =
    (autoplay && playMode !== 'inline') || autoplayFromContext;
  const currentLoop = finishAction === 'replay';

  useLayoutEffect(() => {
    setVideo(currentVideo);
  }, [source]);

  const onPlay = () => {
    if (playMode === 'popup') {
      return;
    }

    if (!playing) {
      setPlaying(true);
    }
  };

  const onPause = () => {
    setPlaying(false);
  };

  const onEnd = () => {
    const events = {
      next: () => nextVideo(),
      replay: () => setPlaying(false)
    };

    return events[finishAction]?.();
  };

  return (
    <VimeoPlayer
      url={player_embed_url}
      autoplay={!displayDeactivation && currentAutoplay}
      loop={currentLoop}
      onPlay={onPlay}
      onPause={onPause}
      onEnd={onEnd}
      item={item}
    />
  );
};
